import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import getInterventionsInfos from '@/services/services/interventions.service';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import registerCount from './count';

const attributesObj = {
  request_status: {
    serverSide: true,
    values: ['1'],
  },
  rejected: {
    serverSide: true,
    values: ['N'],
  },
  is_paused: {
    serverSide: true,
    values: ['O'],
  },
};

export default (store) => {
  store.registerModule(
    ['requests', 'paused'],
    new BaseModule({
      attributesObj,
      sortChoices: ['pause_duration'],
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/dispatched_requests`,
        }),
      }),
      defaultSortBy: ['expiration'],
      makeQueryParams: makeListRequest({
        useEntities: true,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'requests/paused',
    store,
  });

  basePlugin.loadItemsOnCurrentEntityChange();

  if (store.getters['boilerplate/isInit']) {
    store.dispatch('requests/paused/initItems');
  }

  basePlugin.onItemsLoaded((items) => {
    getInterventionsInfos(items)
      .then(async (resultList) => {
        const newItems = items.map((item) => {
          const interventionItem = resultList.find(
            (intervention) => intervention.propertyId === item.property_id
          );
          return {
            ...item,
            interventions_in_progress: interventionItem
              ? interventionItem.list
              : [],
          };
        });
        store.commit('requests/paused/UPDATE_ITEMS', newItems);
      })
      .catch((err) => {
        store.dispatch('snackbar/setError', err);
      });
  });

  store.subscribeAction((action) => {
    if (action.type === 'requests/refreshItems') {
      store.dispatch('requests/paused/refreshItems');
    }
  });

  registerCount(store);
};
